import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import * as moment from 'moment';

export class CustomMomentDateTimeAdapter extends MomentDateTimeAdapter {
    format(date: moment.Moment, displayFormat: any): string {
        return date.format('D, MMM YYYY hh:mm a');
    }

    getLocale(){
        return '';
    }
  }